export default __webpack_public_path__ + "static/media/k_logo_trans_white_large.f1a47d00.png";